<template>
	
	<el-row class="timebook horizontal-timebook">
		
		<el-col :span="24">
			<el-input class="timebook__description" v-model="manualEntry.description" size="large" placeholder="Description..."></el-input>
		</el-col>
		
		<el-col :span="4">
			<el-select placement="bottom" class="timebook-element" v-model="manualEntry.client_id" size="large" placeholder="Select Client" :disabled="preselectClient !== null" style="width: 100%" @change="onChangeClient">
				<el-option v-for="item in $store.state.clients" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
			</el-select>
		</el-col>
		
		<el-col :span="4">
			<el-select placement="bottom" v-model="manualEntry.project_id" size="large" placeholder="Select Project" :disabled="preselectProject !== null" style="width: 100%" @change="onChangeProject">
				<el-option v-for="item in projects" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
			</el-select>
		</el-col>
		
		<el-col :span="4">
			<el-select placement="bottom" v-model="manualEntry.ticket_id" size="large" placeholder="Select Task" style="width: 100%">
				<el-option v-for="item in tickets" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
			</el-select>
		</el-col>
		
		<el-col :span="4">
			<el-select placement="bottom" v-model="manualEntry.category" size="large" placeholder="Select Category" style="width: 100%">
				<el-option v-for="(type, index) in $store.state.ticketTypes" :value="type" :label="type" :key="index">{{ type }}</el-option>
			</el-select>
		</el-col>
		
		<el-col :span="6">
			<!--<el-date-picker v-model="manualEntry.dateRange" type="datetimerange" start-placeholder="Start date" end-placeholder="End date" clearable style="width: 100%;" @change="onChangeDateRange"/>
			-->
			<el-input v-model="dateTimeString" placeholder="Select Date & Time" size="large" :clearable="true" @focus="onFocusDateTime" @blur="onBlurDateTime" @clear="onClearDateTime"></el-input>
			<el-popover v-model="dateTimeVisible" placement="bottom" width="160" trigger="manual">
				<el-date-picker v-model="dateTime" type="date" placeholder="Date" style="width: 100%;" @change="onChangeDateTime"/>
				<el-time-picker v-model="startTimeDate" placeholder="Start Time" style="width: 100%;" value-format="HH:mm" format="HH:mm" @change="onChangeDateTime"/>
				<el-time-picker v-model="endTimeDate" placeholder="End Time" value-format="HH:mm" format="HH:mm" style="width: 100%;" @change="onChangeDateTime"/>
				<el-button type="text" style="width: 100%;" @click="onSaveDateTime">Close</el-button>
			</el-popover>
		</el-col>
		
		<el-col :span="2" style="text-align: right;">
			<el-button class="timebook-action" type="text" icon="el-icon-check" @click="addTimeBookEntry"></el-button>
			<el-popover v-model="deleteConfirmationVisible" class="timebook-action" width="240">
				<p style="margin-top: 0;">Are you sure to reset all fields?</p>
				<div style="text-align: right; margin: 0">
					<el-button size="mini" type="text" @click="deleteConfirmationVisible = false">Cancel</el-button>
					<el-button type="primary" size="mini" @click="resetTimeBookEntry">Yes</el-button>
				</div>
				<el-button slot="reference" type="text" icon="el-icon-close"></el-button>
			</el-popover>
		</el-col>
		
	</el-row>
	
</template>

<script>
	
	const moment = require("moment");
	
	export default {
		
		props: {
			preselectClient: { default: null },
			preselectProject: { default: null },
		},
		
		computed: {
			
			startTimeRange() {
				if (this.endTimeDate) {
					return `00:00 - ${this.endTimeDate}`;
				}
				return `00:00 - 23:59`;
			},
			
			endTimeRange() {
				if (this.startTimeDate) {
					return `${this.startTimeDate} - 23:59`;
				}
				return `00:00 - 23:59`;
			},
			
		},
		
		methods: {
			
			onSaveDateTime() {
				this.onChangeDateTime();
				this.dateTimeVisible = false;
			},
			
			onChangeDateTime() {
				
				let startTime;
				let endTime;
				
				if (this.dateTime && this.startTimeDate) {
					const startTimeSplit = this.startTimeDate.split(":");
					startTime = moment(this.dateTime).hours(startTimeSplit[0]).minutes(startTimeSplit[1]);
				}
				
				if (this.dateTime && this.endTimeDate) {
					const endTimeSplit = this.endTimeDate.split(":");
					endTime = moment(this.dateTime).hours(endTimeSplit[0]).minutes(endTimeSplit[1]);
				}
				
				if (startTime && endTime) {
					
					const duration = moment.duration(endTime.diff(startTime));
					
					const startDateString = startTime.format("D MMMM YYYY, h:mm A");
					const endDateString = endTime.format("h:mm A");
					
					this.manualEntry.date = startTime;
					this.manualEntry.duration = Math.abs(duration.asMilliseconds());
					
					this.dateTimeString = `${startDateString} - ${endDateString}`;
					
				}
				
			},
			
			onBlurDateTime() {
				//this.dateTimeVisible = false;
			},
			
			onFocusDateTime() {
				this.dateTimeVisible = true;
			},
			
			onClearDateTime() {
				this.dateTime = null;
				this.startTimeDate = null;
				this.endTimeDate = null;
				this.dateTimeString = "";
			},
			
			onChangeProject(id) {
				
				// Reset ticket.
				
				this.manualEntry.ticket_id = null;
				
				this.tickets = [];
				
				// Find this project's tickets.
				
				this.projects.map((data, i) => {
					if (data.id == id) {
						this.axios.get("projects/" + data.slug).then((response) => {
							this.tickets = response.data[0].tickets;
						});
					}
				});
				
			},
			
			onChangeClient(id) {
				
				// Reset project and ticket.
				
				this.manualEntry.project_id = null;
				this.manualEntry.ticket_id = null;
				
				this.projects = [];
				this.tickets = [];
				
				// Find this client's projects.
				
				this.$store.state.clients.map((data, i) => {
					if (data.id == id) {
						this.projects = data.projects;
					}
				});
				
			},
			
			/*onChangeDateRange(dateRange) {
				
				const startDate = dateRange[0];
				const endDate = dateRange[1];
				
				this.manualEntry.date = startDate;
				this.manualEntry.duration = Math.abs(endDate.getTime() - startDate.getTime());
				
			},*/
			
			/*onChangeDuration(duration) {
				
				if (duration) {
					
					const h = duration.getHours();
					const m = duration.getMinutes();
					const s = duration.getSeconds();
					
					const seconds = (+h) * 60 * 60 + (+m) * 60 + (+s); 
					const milliseconds = (seconds * 1000);
					
					this.manualEntry.milliseconds = milliseconds;
					
				}
				
			},*/
			
			resetTimeBookEntry() {
				
				if (!this.preselectClient) {
					this.manualEntry.client_id = null;
				}
				
				if (!this.preselectProject) {
					this.projects = [];
					this.tickets = []; 
					this.manualEntry.project_id = null;
				}
				
				if (!this.preselectTicket) {
					this.manualEntry.ticket_id = null;
				}
				
				this.manualEntry.description = "";
				this.manualEntry.duration = 0;
				this.manualEntry.date = null;
				this.manualEntry.category = null;
				
				this.deleteConfirmationVisible = false;
				
				this.onClearDateTime();
				
			},
			
			addTimeBookEntry() {
				
				// Have they filled in the required details?
				
				if (this.manualEntry.description.trim() == "" || this.manualEntry.milliseconds == 0) {
					
					this.$Notice.warning({
						title: "Whoops!",
						desc: "Please fill in the required fields before adding this entry.",
					});
					
					return;
					
				}
				
				// Loading...
				
				this.$store.commit("setLoading", {type: "start"});
				
				// Post!
				
				this.axios.post("timebook", {
					
					client_id: this.manualEntry.client_id,
					project_id: this.manualEntry.project_id,
					ticket_id: this.manualEntry.ticket_id,
					
					description: this.manualEntry.description,
					duration: this.manualEntry.duration,
					date: this.manualEntry.date,
					category: this.manualEntry.category,
					manual: 1,
					
					user_id: this.$auth.user().id,
					
				}).then((response) => {
					
					// Success or not?
					
					if (response.statusText == "OK") {
						
						// Not loading anymore.
						
						this.$store.commit("setLoading", {type: "finish", message: "This timebook entry has been added."});
						
						// Emit event.
						
						this.$emit("on-add", {error: false, success: true, axios: response});
						
						// Reset time book entry.
						
						this.resetTimeBookEntry();
						
					} else {
						
						this.$store.commit("setLoading", {type: "error", message: "An unknown error occurred while adding this timebook entry."});
						
					}
					
				}).catch((e) => {
					
					this.$store.commit("setLoading", {type: "error", message: "An unknown error occurred while adding this timebook entry."});
					
				});
				
			},
			
		},
		
		mounted() {
			
			// Preselect client?
			
			if (this.preselectClient) {
				this.manualEntry.client_id = this.preselectClient;
				this.onChangeClient(this.preselectClient);
			}
			
			// Preselect daterange?
			
			if (this.preselectProject) {
				this.manualEntry.project_id = this.preselectProject;
				this.onChangeProject(this.preselectProject);
			}
			
		},
		
		data() {
			
			return {
				
				manualEntry: {
					
					client_id: null,
					project_id: null,
					ticket_id: null,
					
					description: "",
					duration: 0,
					date: null,
					category: null,
					
				},
				
				projects: [],
				
				tickets: [],
				
				dateTime: null,
				startTimeDate: null,
				endTimeDate: null,
				
				dateTimeVisible: false,
				dateTimeString: "",
				
				deleteConfirmationVisible: false,
				
			}
			
		},
		
	}
	
</script>

<style scoped>
	
	.timebook__description {
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	}
	
	/deep/ .el-input__inner {
		border: 0 !important;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/TimeBook/ManualEntry.vue